export enum InDirectAnswersId {
    //Positive Answers
    externalApk = '018d210e-48e1-7dee-8c38-38a61862ee09',
    clientConsentForAPK = '018d210e-48e1-7dee-8c38-38a6195ca2c8',
    propertyInsurance = '018d210e-48e1-7dee-8c38-38a61a959f16',
    businessActivity = '018d210e-48e1-7dee-8c38-38a61b914654',
    businessActivityInGarageOrFarmBuilding = '018d210e-48e1-7dee-8c38-38a61c83e532',
    availableBusinessActivity = '018d210e-48e1-7dee-8c38-38a61ce294ff',
    businessActivityArea = '018d210e-48e1-7dee-8c38-38a61de2a7a1',
    farm = '018d210e-48e1-7dee-8c38-38a61e2959f3',
    onlyHouse = '018d210e-48e1-7dee-8c38-38a61ef4a512',
    oc = '018d210e-48e1-7dee-8c38-38a61fe75fb1',
    nnw = '018d210e-48e1-7dee-8c38-38a6202510e7',

    // Negative Answers
    externalApk_No = '018d210e-48e1-7dee-8c38-38a61863dd08',
    clientConsentForAPK_No = '018d210e-48e1-7dee-8c38-38a61a4fa9dd',
    propertyInsurance_No = '018d210e-48e1-7dee-8c38-38a61aa754cf',
    businessActivity_No = '018d210e-48e1-7dee-8c38-38a61c2eaef0',
    businessActivityInGarageOrFarmBuilding_No = '018d210e-48e1-7dee-8c38-38a61c98a904',
    availableBusinessActivity_No = '018d210e-48e1-7dee-8c38-38a61da4d2be',
    businessActivityArea_No = '018d210e-48e1-7dee-8c38-38a61de9c696',
    farm_No = '018d210e-48e1-7dee-8c38-38a61e85cb33',
    onlyHouse_No = '018d210e-48e1-7dee-8c38-38a61f990943',
    oc_No = '018d210e-48e1-7dee-8c38-38a620159ef8',
    nnw_No = '018d210e-48e1-7dee-8c38-38a62068a504',
}